module.exports = __webpack_public_path__ + "img/social2espanol.23ac237b.png";